'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import UserProfile from 'MeetingsBase/models/UserProfile';
import Branding from 'MeetingsBase/models/Branding';
import { DISPLAY_AVATAR_OPTION } from 'MeetingsBase/constants/enums';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UIFlex from 'UIComponents/layout/UIFlex';
import { getBookInfo as getBookInfoSelector } from 'MeetingsLib/selectors/BookInfoSelectors';
import { LINK_TYPES, MEETING_TYPES } from 'MeetingsBase/constants/enums';
import get from 'transmute/get';
import DatePicker from 'MeetingsLib/components/schedule/date/DatePicker';
import ProfileHeader from 'MeetingsLib/components/header/ProfileHeader';
import ColoredCard from 'MeetingsLib/components/decorative/ColoredCard';

var getDisplayAvatarOption = function getDisplayAvatarOption(displayAvatarOption, customAvatar, companyAvatar, isPersonal) {
  switch (displayAvatarOption) {
    case DISPLAY_AVATAR_OPTION.PROFILE_IMAGE:
      return null;

    case DISPLAY_AVATAR_OPTION.COMPANY_LOGO:
      // Most RR links will fall here. Fallack to uploaded avatar
      return companyAvatar || customAvatar;

    case DISPLAY_AVATAR_OPTION.CUSTOM_AVATAR:
      return customAvatar;

    default:
      // Hotfix for unset displayAvatarOption
      return isPersonal ? customAvatar || null : customAvatar || companyAvatar || null;
  }
};

var DatePickerSection = createReactClass({
  displayName: "DatePickerSection",
  propTypes: {
    // passed
    avatar: PropTypes.string,
    companyAvatar: PropTypes.string,
    branding: PropTypes.instanceOf(Branding).isRequired,
    displayAvatarOption: PropTypes.string,
    compact: PropTypes.bool,
    linkType: PropTypes.string,
    headline: PropTypes.string,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    DatePickerMarker: PropTypes.func.isRequired,
    TimePickerMarker: PropTypes.func.isRequired,
    // loaded
    isSalesStarter: PropTypes.bool,
    setEventDate: PropTypes.func.isRequired
  },
  render: function render() {
    var _this$props = this.props,
        avatar = _this$props.avatar,
        companyAvatar = _this$props.companyAvatar,
        displayAvatarOption = _this$props.displayAvatarOption,
        branding = _this$props.branding,
        compact = _this$props.compact,
        headline = _this$props.headline,
        profile = _this$props.profile,
        setEventDate = _this$props.setEventDate,
        isSalesStarter = _this$props.isSalesStarter,
        DatePickerMarker = _this$props.DatePickerMarker,
        TimePickerMarker = _this$props.TimePickerMarker,
        linkType = _this$props.linkType;
    var isPersonal = linkType === LINK_TYPES.get(MEETING_TYPES.PERSONAL);
    var avatarUrl = getDisplayAvatarOption(displayAvatarOption, avatar, companyAvatar, isPersonal);
    return /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      children: [/*#__PURE__*/_jsxs(ColoredCard, {
        className: "date-picker-section m-bottom-0 flex-grow-1",
        cardSectionClassName: "m-bottom-0 p-x-0 p-y-4 flex-column flex-grow-1 justify-center",
        branding: branding,
        children: [/*#__PURE__*/_jsx(ProfileHeader, {
          avatar: avatarUrl,
          booked: false,
          headline: headline,
          profile: profile
        }), /*#__PURE__*/_jsx(DatePicker, {
          compact: compact,
          profile: profile,
          branding: branding,
          setEventDate: setEventDate,
          DatePickerMarker: DatePickerMarker,
          TimePickerMarker: TimePickerMarker
        })]
      }), compact && !isSalesStarter && /*#__PURE__*/_jsx("div", {
        style: {
          height: 48,
          width: '100%',
          flexShrink: 0
        }
      })]
    });
  }
});
export default connect(function (state) {
  return {
    isSalesStarter: state.isSalesStarter,
    linkType: get('linkType', getBookInfoSelector(state))
  };
}, Object.assign({}, FormActions))(DatePickerSection);